import {FormuleEnum} from "@shared/enums/formule.enum";

export class BorderPreconisation {
    selected: boolean;
    formuleEnum: FormuleEnum;
    border: any;

    constructor(f: FormuleEnum, selected: boolean = false) {
        this.formuleEnum = f;
        this.selected    = selected;
        this.border      = selected ? {
                "border-top": "5px solid black",
                "border-left": "5px solid black",
                "border-right": "5px solid black",
                "border-bottom": "5px solid black"
            } :
           {
               "border-top": "5px solid white",
               "border-left": "5px solid white",
               "border-right": "5px solid white",
               "border-bottom": "7px solid #EEEEEE"
           };
    }
}
